export const Bio = {
  name: "Swarnamugi - Obstacle Slayer",
  roles: [
    "Full Stack Developer",
    "Software Developer",
    "Salesforce Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/SwarnamugiM",
  resume:
    "https://drive.google.com/drive/folders/1Byr1PsLxdZZP3jVpXx4tdknFLUGvtphB",
  linkedin: "https://www.linkedin.com/in/swarnamugi-m-084859227/",
  //Salesforce: "https://www.salesforce.com/trailblazer/cswarnamugi",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
 
   

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
     
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Flask",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQidxvbGW2CXpFO4WEgjY5a_3B7jyaoem78NA&s",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
   
      
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-2048x2026-lg873y7v.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn3d.iconscout.com/3d/free/thumb/free-git-3d-icon-download-in-png-blend-fbx-gltf-file-formats--github-logo-version-control-system-vcs-coding-lang-pack-logos-icons-7578021.png?f=webp",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
   
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      
      {
        name: "Netbeans",
        image:
          "https://cdn3d.iconscout.com/3d/free/thumb/free-netbeans-3d-logo-download-in-png-blend-fbx-gltf-file-formats--company-brand-social-media-pack-logos-4781225.png?f=webp",
      },
      
      {
        name: "PowerBI",
        image: "https://pbs.twimg.com/media/FR0yy7sWQAE-7KA.png",
      },
      {
        name: "Salesforce",
        image:
          "https://static-00.iconduck.com/assets.00/salesforce-icon-1024x717-zsvxc6sf.png",
      },
      {
        name: "AWS - Cloud Platform",
        image:
          "https://c8.alamy.com/comp/2KA01EA/aws-amazon-web-services-2KA01EA.jpg",
      },
      {
        name: "Tomcat",
        image:
          "https://dyltqmyl993wv.cloudfront.net/assets/stacks/tomcat/img/tomcat-stack-220x234.png",
      },
     
    
    ],
  },
];

export const experiences = [
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/v2/C5603AQEXq-PG-aWE4w/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1641464463556?e=2147483647&v=beta&t=y8IDqQzhDED5TQq1DyltCUG3Li8ag4YfHF1qVXuU7qY",
    role: "JAVA ",
    company: "Spencer Soft",
    date: "Dec 2022",
    desc: "Java is a versatile, object-oriented programming language designed for building platform-independent applications through the Java Virtual Machine (JVM). It is widely used for developing web applications, mobile apps, enterprise software, and embedded systems, emphasizing portability, security, and performance.",
    doc: "https://drive.google.com/file/d/1RwT8kcvJl8q7UZV4Do1ldddzpBpOS0nE/view?usp=sharing",
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxOxBrHkPdWoy3fE1KEsdIi2rKwTBZ_sVrcAum8TgdzR0rCEM9SkJCMV2iIs3J4yzGBDI&usqp=CAU",
    role: "Slesforce Developer Foundation Intern",
    company: "Inno Valley Works Pvt. Ltd.",
    date: "May 2023",
    desc: "Working on Salesforce trailhead Platform.",
    skills: [
      "Salesforce fundamentals",
      "Trailhead fundamentals",
      "Visualforce",
      "Lightning Framework",
      "Lightning App Builder",
      "Trailblazer",
    ],
    doc:"https://drive.google.com/file/d/1feSGVUXvK821z5PLli2yoKLA6H8KNpfe/view?usp=sharing",
  },
  {
    id: 4,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSG9DFOeykYecKnzfOkr3-knnvESR2CKrBJMmuN7RBjCUtfW6_d2Al63GAu1NhGdupv86c&usqp=CAU",
    role: "Fullstack Web Development",
    company: "Traing Trains",
    date: "June 2023",
    desc: "Full stack web development refers to the process of developing both the front end (client side) and back end (server side) of a web application. It involves working with technologies like HTML, CSS, JavaScript for the front end, and server-side languages, databases for the back end.",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "PHP",
      "Bootstrap",
    ],
    doc: "https://drive.google.com/file/d/1bZJZyIP3i0jXUVASUUmQ3s5wieaeJhL9/view?usp=sharing",
  },
  {
    id: 0,
    img: "https://connect.eduskillsfoundation.org/connect_2023/assets/frontend/img/new-logo2.png",
    role: "AI - ML Internship",
    company: "Eduskills",
    date: "April 2024 - June 2024",
    desc: "Artificial Intelligence (AI) refers to the simulation of human intelligence in machines, enabling them to perform tasks such as learning, reasoning, and problem-solving. Machine Learning (ML), a subset of AI, focuses on developing algorithms that allow computers to learn from and make predictions or decisions based on data without explicit programming.",
    skills: [
      "Tensorflow",
      "Codelab",
      "Object Detection",
      "product image search",
      "Image classification",
      "Backend mobile app",
      "Neural Networks",
    ],
    doc: "https://drive.google.com/file/d/1Dl6KPRQ_3tqWdvEQo3_xXqSsLm2-vcsE/view?usp=sharing",
    
  },

  {
    id: 2,
    img: "https://www.svgrepo.com/show/353810/google-developers.svg",
    role: "Google for Developers",
    desc: "Google for Developers is a platform that provides tools, APIs, and resources to help developers build applications using Google's technologies, such as Android, Cloud, and AI.",
    doc: "https://g.dev/SWARNAMUGI_KIT",
  },


 
];

export const education = [
  {
    id: 0,
    img: "https://images.shiksha.com/mediadata/images/1592220407phptVtXhp.jpeg",
    school: "KIT-Kalaignarkarunanidhi Institute of Technology, Coimbatore",
    date: "June 2021 - July 2025",
    grade: "8.71 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Business Systems at Kalaignarkarunanidhi  Institute of Technology, Coimbatore. I have completed 6 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, Fundamentals of mangement, fundamentals of Accounts , Devops, Software Engineering among others. I am also a member of the Google Developers Student Club (GDSC), where I am learning and working on exciting projects.",
    degree: "Bachelor of Technology - BTech, Computer Science and Business Systems",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9rf5Id4VzSs0rvgQW-fmHztXdZfRO6mhSPQ&s",
    school: "Kadri Mills Higher Secondary School,Coimbatore",
    date: "Apr 2019 - Apr 2021",
    grade: "88.6%",
    desc: "I completed my class 12 high school education at Kadri Mills Higher Secondary School, Coimbatore, where I studied Science with Computer Science.",
    degree: "HSC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9rf5Id4VzSs0rvgQW-fmHztXdZfRO6mhSPQ&s",
    school: "Kadri Mills Higher Secondary School, Coimbatore",
    date: "Apr 2017 - Apr 2019",
    grade: "82%",
    desc: "I completed my class 10 education at Kadri Mills Higher Secondary School, Coimbatore.",
    degree: "SSC(X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "Call Center Using Java",
    
    description:
      "Call center is a web application to implementing technologies like IVR (Interactive Voice Response),reducing manual intervention, Overall, call center automation aims to optimize workflows, minimize wait times, and deliver seamless experiences for both customers and agents.",
    image:
      "https://github.com/SwarnamugiM/Call-center-automation/blob/main/WhatsApp%20Image%202024-10-21%20at%2018.55.46_ada555af.jpg?raw=true",
    tags: [
      "Java",
      "PHP",
      "Netbens",
      "Tomcat",
      "Xampp",
    ],
    category: "web app",
    github: "https://github.com/SwarnamugiM/Call-center-automation.git",
    
  },
  

  {
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://camo.githubusercontent.com/65822b6200e1205ae66a3fbbb474175e0111ff9ebed23a4a04e4d2a2409370aa/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/SwarnamugiM/Todo-Web-App",
    webapp: "https://rishav-react-todo.netlify.app/",
  },

  {
    id: 7,
    title: "Quiz App",
    date: "Dec 2020 - Jan 2021",
    description:
      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    category: "android app",
    github: "https://github.com/SwarnamugiM/Quiz-Android-APP",
    webapp: "https://github.com/rishavchanda/Quiz-Earn",
  },
  {

    id: 8,
    title: "PetCare-AI-Chatbot",
    
    description:
      "LLM-based Chatbot for PetCare. The app is built on open source stack and useful for Vet Doctors, Pet Lovers, etc. Supercharge your PetCare conversations with our lightning-fast AI chatbot powered by Llama 2.",
    image:
      "https://media.licdn.com/dms/image/v2/D5612AQFcTDrqbwdLzQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1714290869373?e=2147483647&v=beta&t=g9jtI1KF7PZ0tjcF3wXLhlVk0V78uOUORVom-f9UY68",
    tags: ["Python", "FastAPI", "Json", "Html","CSS","JS"],
    category: "AI",
    github: "https://github.com/SwarnamugiM/PetCare-AI-Llama-Chatbot.git",
   
  },

];


